import { DashboardCardNameEnum } from "@ryde/shared";

import { IDashboardCard } from "./dynamic-dashboard.models";
import { DASHBOARD_SYSTEM_CARDS } from "./dynamic-dashboard.system-cards.constants";
import { buildSystemCard } from "./dynamic-dashboard.system-cards.utils";

/**
 * The cards the "Default" layout places, as `Legacy` cards so they reuse the real
 * card components + live data and look identical to the current dashboard.
 *
 * Listed explicitly rather than derived from `DASHBOARD_SYSTEM_CARDS`: these are
 * the six cards the dashboard has always shown, and every tenant sees them. The
 * PRD's three KPI cards are Rail-specific, so they are offered in the card editor
 * instead of being pushed into everyone's default — and into `resetToDefault`,
 * which existing users press expecting the dashboard they know. A Rail default
 * View is the PRD's own later phase.
 */
const DEFAULT_LAYOUT_CARD_NAMES: DashboardCardNameEnum[] = [
  DashboardCardNameEnum.RIDE_PAGE_MANUAL_CHANGES_OVERALL,
  DashboardCardNameEnum.OVERALL_COST,
  DashboardCardNameEnum.STATUS_NEW_BOOKINGS,
  DashboardCardNameEnum.RIDE_PAGE_MANUAL_CHANGES_PER_USER,
  DashboardCardNameEnum.VEHICLE_TYPE_RIDES_COST,
  DashboardCardNameEnum.RIDES_SUPPLIERS,
];

/** This is what loads when no saved view is default, and what `resetToDefault` restores. */
export const DASHBOARD_DEFAULT_CARDS: IDashboardCard[] =
  DEFAULT_LAYOUT_CARD_NAMES.flatMap(cardName => {
    const definition = DASHBOARD_SYSTEM_CARDS.find(
      item => item.cardName === cardName,
    );

    return definition ? [buildSystemCard({ definition, id: cardName })] : [];
  });
